// extracted by mini-css-extract-plugin
module.exports = {"methodTitle":"MethodType_methodTitle__4L3RU","label":"MethodType_label__56p9Q","checkedRadio":"MethodType_checkedRadio__RWdp2"};